import * as Yup from "yup";
//@ts-ignore cortex
import { trans } from "@cortexglobal/rla-intl";

export const CommentSchema = Yup.object().shape({
    comment: Yup.string()
        .min(2)
        .required(trans("Please enter a comment"))
});
